import { render, staticRenderFns } from "./TagsListEdit.vue?vue&type=template&id=12dee4e2&"
import script from "./TagsListEdit.vue?vue&type=script&lang=js&"
export * from "./TagsListEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports